<app-side-menu>
  <div class="content-wrapper">
    <div class="profile-container">
      <!-- Header -->
      <div class="profile-header">
        <h2 class="profile-title">Informações Pessoais</h2>
      </div>

      <!-- User Avatar -->
      <div class="profile-avatar-section">
        <div class="profile-avatar">
          <img *ngIf="avatarUrl" [src]="avatarUrl" alt="Foto de perfil" class="avatar-image">
          <div class="avatar-placeholder" *ngIf="!avatarUrl">
            <i class="fas fa-user"></i>
          </div>
        </div>
        <div class="avatar-actions">
          <button class="btn-change-photo" (click)="triggerFileInput()" [disabled]="uploadingAvatar">
            <i class="fas fa-camera"></i> {{ avatarUrl ? 'Alterar Foto' : 'Adicionar Foto' }}
          </button>
        </div>
        <input type="file" id="avatarInput" accept="image/*" (change)="onFileSelected($event)" style="display: none;">
      </div>

      <!-- Cropper Modal -->
      <div class="cropper-modal" *ngIf="showCropper">
        <div class="cropper-overlay" (click)="cancelCrop()"></div>
        <div class="cropper-container">
          <div class="cropper-header">
            <h3>Recortar Imagem</h3>
            <button class="btn-close" (click)="cancelCrop()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="cropper-body">
            <div class="cropper-instructions">
              <p><i class="fas fa-info-circle"></i> Arraste para posicionar • Role para dar zoom</p>
            </div>
            <canvas 
              #imageCanvas
              class="cropper-canvas"
              (mousedown)="onCanvasMouseDown($event)"
              (mousemove)="onCanvasMouseMove($event)"
              (mouseup)="onCanvasMouseUp()"
              (mouseleave)="onCanvasMouseUp()"
              (wheel)="onCanvasWheel($event)">
            </canvas>
          </div>
          <div class="cropper-footer">
            <button class="btn-cancel" (click)="cancelCrop()" [disabled]="uploadingAvatar">
              Cancelar
            </button>
            <button class="btn-save" (click)="saveCroppedImage()" [disabled]="uploadingAvatar">
              <i class="fas fa-spinner fa-spin" *ngIf="uploadingAvatar"></i>
              {{ uploadingAvatar ? 'Salvando...' : 'Salvar Foto' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Profile Name Highlighted -->
      <div class="profile-profile-row">
        <span class="profile-badge">
          {{ userProfile?.NameProfile || 'Perfil não definido' }}
        </span>
      </div>

      <!-- User Information Form -->
      <div class="profile-form">
        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Nome Completo</label>
            <input type="text" class="form-control" [value]="userName || 'Carregando...'" readonly>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Email</label>
            <input type="email" class="form-control" [value]="userEmail || 'Carregando...'" readonly>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Data de Criação</label>
            <input type="text" class="form-control" [value]="userProfile?.CreatedAt ? (userProfile.CreatedAt | date:'dd/MM/yyyy HH:mm') : 'N/A'" readonly>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Vendedor</label>
            <input
              type="text"
              class="form-control"
              [value]="
                userProfile?.IsSeller === true
                  ? 'Sim'
                  : userProfile?.IsSeller === false
                    ? 'Não'
                    : 'N/A'
              "
              readonly
            >
          </div>
        </div>

        <div class="form-row form-row-two">
          <div class="form-group">
            <label class="form-label">Departamento</label>
            <input type="text" class="form-control" [value]="userProfile?.Staff?.Department || userProfile?.Staff?.DepartmentName || 'N/A'" readonly>
          </div>
          <div class="form-group">
            <label class="form-label">Posição</label>
            <input type="text" class="form-control" [value]="userProfile?.Staff?.Position || userProfile?.Staff?.PositionName || 'N/A'" readonly>
          </div>
        </div>

        <div class="form-row form-row-two">
          <div class="form-group">
            <label class="form-label">Gerente</label>
            <input type="text" class="form-control" [value]="userProfile?.Staff?.Manager || userProfile?.Staff?.ManagerName || 'N/A'" readonly>
          </div>
          <div class="form-group">
            <label class="form-label">Data de Contratação</label>
            <input type="text" class="form-control" [value]="userProfile?.Staff?.HireDate ? (userProfile.Staff.HireDate | date:'dd/MM/yyyy') : 'N/A'" readonly>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="profile-actions">
        <button class="btn-logout" (click)="logout()">
          Sair do Sistema
        </button>
      </div>
    </div>
  </div>
</app-side-menu>